<!--本页为左侧下拉菜单-->
<template lang="pug">
#operationsMgContainer()
  .leftMeau(:class="{'closeMeau':!isCollapse}")
    el-menu.docNav(
      :collapse="!isCollapse"
      :default-active="defaultactivePath"
      style="padding-top: var(--middle-space)"
      :unique-opened="false" :collapse-transition="false" )
      div(v-for="(item, num) of navList" :key="num")
        el-submenu(v-if="item.sub.length > 0" :index="item.path" popper-class="popperStyle")
          template(slot="title")
            .titleBox
              img(:src="item.icon2" v-if="queshow(item)" alt="图片")
              img(:src="item.icon1" v-else alt="图片")
              span(v-if="isCollapse" :title="item.name") {{ item.name }}
              i.el-icon-circle-plus-outline(title="新增部门分类" v-if="isCollapse&&isDept(item)&&addDoc" @click.stop="addDepClassOpen")
          el-menu-item( v-for="sub2 of item.sub" :index="sub2.path" :key="sub2.path" @click="goNext(sub2)" )
            .titleBoxChild
              img(:src="folder" alt="图片")
              span(:title="sub2.name") {{ sub2.name }}
              i.el-icon-edit-outline(title="修改" v-if="sub2.noPath&&sub2.folderId!=='recycle'&&updateDoc" @click.stop="editDepClass(sub2)")
              i.el-icon-delete( title="删除" v-if="sub2.noPath&&sub2.folderId!=='recycle'&&deleteDoc" @click.stop="delDepClass(sub2)")
        el-menu-item(v-else :index="item.path" @click="goNext(item)" popper-class="popperStyle")
          .titleBox
            img(:src="item.icon2" v-if="queshow(item)" alt="图片")
            img(:src="item.icon1" v-else alt="图片")
            span(v-if="isCollapse") {{ item.name }}
  switchBtn(:show.sync="isCollapse")
  .rightContent(:class="{'openMeau':!isCollapse}")
    router-view
</template>

<script>
import switchBtn from "@/CommonDP/components/switch/switchBtn.vue";
import { mapState } from "vuex";
import { getMenuList } from "@/CommonDP/utils/tree";
import secondaryMenuService from "@/CommonDP/service/secondaryMenu-service.js";
import { addDeptDialog } from "./common.js";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
export default {
  name: "Knowledge",
  components: { switchBtn },
  data() {
    return {
      isCollapse: true,
      folder: require("@/CommonDP/assets/doc/文件夹.png"),
      navList: [],
      addDoc: checkPermission(this.$allPerms.DOC_ADD),
      deleteDoc: checkPermission(this.$allPerms.DOC_DELETE),
      updateDoc: checkPermission(this.$allPerms.DOC_UPDATE)
    };
  },
  computed: {
    ...mapState({
      authRoutes: (state) => state.router.authRoutes,
      enterpriseId: state => state.enterprise.enterpriseId
    }),
    navName() {
      return this.$route.matched[1].name;
    },
    defaultactivePath() {
      const { path, query: { fileId = "", fileName = "" }} = this.$route;
      if (fileId) {
        return path + "?fileId=" + fileId + "&fileName=" + fileName;
      } else {
        return path;
      }
    },
    deptParams() {
      return {
        folderId: "0",
        isRead: 1,
        priviAll: "1",
        enterpriseId: this.enterpriseId,
        type: "",
        versionId: ""
      };
    },
    navArr() {
      const meauList = this.authRoutes.find(({ permissionKey }) => permissionKey === this.navName);
      const list = getMenuList([meauList]) || [];
      return list[0].sub;
    }
  },
  mounted () {
    this.getList();
  },
  methods: {
    async getList () {
      this.navList = [];
      const { data } = await secondaryMenuService.queryEnterpriseDept(this.deptParams);
      const sub = [];
      // 部门文档添加url参数文件id和文件名称
      for (const itear of data) {
        const obj = { ...itear, id: itear.folderId, name: itear.folderName, noPath: true,
          path: "/enterpriseDeptDoc?fileId=" + itear.folderId + "&fileName=" + itear.folderName };
        sub.push(obj);
      }
      this.navList = this.navArr.map(element => {
        if (this.isDept(element)) {
          return { ...element, sub: sub };
        } else {
          return element;
        }
      });
    },
    isDept(row) {
      return row.id === "PERM9966718590844928" || row.name === "部门文档" || row.permissionKey === "enterpriseDeptDoc";
    },
    goNext(item) {
      this.$router.push(item.path);
    },
    // 修改部门分类
    async editDepClass(val) {
      const { folderId } = val;
      await addDeptDialog({ folderId });
      this.getList();
    },
    // 删除部门
    async delDepClass(val) {
      const { folderId, folderName } = val;
      await this.$confirm(`确定删除文档：${folderName} 吗? 注意：此操作不可恢复`);
      await secondaryMenuService.delEnterpriseDept(folderId);
      this.$message.success("删除成功");
      this.getList();
    },
    // 新增部门分类
    async addDepClassOpen() {
      await addDeptDialog();
      this.getList();
    },
    queshow(children) {
      for (var i = 0; i < children.sub.length; i++) {
        if (children.name + "/" + children.sub[i].name === this.defaultactivePath) {
          return true;
        }
      }
    },
    activePath() {
      if (this.$route.matched[3]) {
        return this.$route.matched[3].path;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/CommonDP/styles/mixin";
$--primary-light: mix($--color-white, $--color-primary, 92%);
#operationsMgContainer {
  width: 100%;
  height: 100%;
  padding: var(--middle-space);
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  .leftMeau{
    width: 130px;
    background-color: #fff;
    height: 100%;
    border-radius: 4px;
    overflow: hidden;
  }
  .closeMeau{
    width: 35px;
  }
  .rightContent{
    width: calc(100% - 142px);
    background-color: #fff;
  }
  .openMeau{
    width: calc(100% - 47px);
  }
  .el-menu {
    height: 100%;
    overflow-y: hidden;
    border-right:0;

    &:hover {
      overflow-y: auto;
    }
  }
  // 子级
  .el-menu-item {
    overflow: hidden;
    height: 36px !important;
    line-height: 36px !important;
    padding-left: var(--small-space) !important;
    margin-bottom: var(--middle-space) !important;
    border-right: 2px solid $--color-white;
    span {
      font-size: 14px !important;
      width: 92px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  /deep/.el-submenu{
    overflow: hidden;
  }
  // 父级
  /deep/ .el-submenu__title {
    height: 36px !important;
    line-height: 36px !important;
    padding-left: var(--small-space) !important;
    margin-bottom: var(--middle-space) !important;
    border-right: 2px solid $--color-white;
    span {
      font-size: 14px !important;
      width: 85px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  // 二级
  /deep/ .el-submenu .el-menu-item {
    padding-left: 30px !important;
    margin-bottom: var(--middle-space) !important;
  }

  // 悬浮
  /deep/ .el-menu-item:hover {
    background-color: $--primary-light !important;
    border-right: 2px solid $--color-primary;
  }
  /deep/ .el-submenu__title:hover {
    background-color: $--primary-light !important;
    border-right: 2px solid $--color-primary;
  }
  // 点击高亮
  /deep/.el-menu-item.is-active {
    // 高亮
    background: $--primary-light !important;
    .titleBoxChild{
      color: $--color-primary;
      border-right: 2px solid $--color-primary;
    }
  }
  /deep/ .el-submenu__icon-arrow {
    right: 5px;
  }
  .el-menu--collapse {
    width: 81px !important;
  }
}
.titleBoxChild{
  width: calc(100% - 25px);
  display: flex;
  flex-direction: row;
  align-items: center;
  img{
    margin-right: 5px;
  }
  i{
    font-size: 14px;
  }
}
.titleBoxChild:hover{
  border-right: 2px solid $--color-primary;
}
.titleBoxChild img{
  width: 16px;
  height: 16px;
}
.titleBox{
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  i{
    font-size: 14px;
  }
  .el-icon-circle-plus-outline{
    font-size: 16px;
    color: $--color-primary;
  }
}
</style>
<style lang="scss">
.el-menu--vertical.popperStyle{
  .el-menu--popup{
    display: none;
  }
}
</style>

